<template>
  <svg
    width="1875"
    height="1055"
    viewBox="0 0 1875 1055"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1521_20445)">
      <g clip-path="url(#clip1_1521_20445)">
        <path
          d="M1281.74 458.62L1239.44 456.546L1233.4 456.744L1241.01 454.621L1256.17 453.367L1279.24 454.519V454.166L1360.04 463.573L1281.74 458.62ZM1691.01 575.066L1690.53 570.451L1689.87 566.579L1688.54 562.709L1686.82 558.392L1684.45 554.372L1679.14 547.302L1675.07 543.06L1669.37 538.447L1589.99 476.092L1586.44 473.935L1581.79 471.48L1577.29 469.584L1572.88 468.059L1568.14 466.871L1563.47 466.109L1559.51 465.59L1556.08 465.406L1550.92 465.481L1546.03 465.745L1542.9 466.155L1537.46 467.237L1533.75 468.356L1529.82 469.772L1519.4 474.505L1457.14 504.086L1342.03 560.718L1272.2 594.101L1266.89 597.378L1263.01 600.88L1259.41 604.901L1256.48 609.666L1254.68 613.539L1254.3 614.679L1253.5 619.405L1253.44 623.72L1253.74 633.029L1253.38 635.888L1252.61 638.828L1251.43 641.294L1249.72 643.877L1247.54 646.683L1245.43 648.804L1242.91 650.855L1239.87 652.613L1236.62 654.305L1233.96 655.35L1229.93 656.643L1222.93 658.313L1143.06 675.256L1138.81 675.586L1137.98 675.608L1131 675.36L1127.73 674.951L1124.91 674.362L1121.95 673.444L1118.81 672.303L1114.41 669.975L1111.98 668.423L1108.53 665.295L1106.9 663.558L1105.2 661.291L1103.85 658.811L1102.81 656.412L1101.94 653.527L1101.42 650.368L1101.39 647.82L1101.77 645.074L1102.62 642.27L1104.27 637.94L1109.88 626.928L1164.39 532.325L1179.09 506.486L1185.16 496.473L1187.29 493.531L1189.9 490.534L1195.39 485.376L1200.13 481.912L1203.25 479.789L1208.32 476.623L1213.01 474.164L1217.23 472.264L1222.87 470.176L1227.13 469.021L1231.21 468.274L1234.86 467.807L1238.39 467.6L1242.2 467.543L1251.68 467.836L1262.3 468.419L1398.09 479.143L1407.55 479.29L1416.37 478.466L1424.43 476.676L1430.78 474.439L1437.03 471.682L1444.38 467.063L1449.39 462.856L1454.79 457.232L1457.78 453.694L1460.52 449.151L1462.79 443.046L1464.02 437.61L1464.96 430.017L1465.69 383.115V382.552L1465.68 371.204L1464.68 364.987L1463.77 362.159L1461.83 357.991L1459.79 354.605L1457.27 351.739L1454.15 348.65L1451.53 346.269L1448.5 343.962L1444.8 341.619L1441.3 339.76L1436.94 337.938L1429.96 335.706L1425.13 334.889L1411.25 333.407L1260.23 318.095H1260.23L1174.74 310.188L1148.07 307.723L1079.47 301.381L1072.72 300.742L1011.26 294.915L953.598 289.448L936.314 287.81L852.621 279.876L829.878 277.851L761.22 271.735L739.144 269.769L701.785 266.443L560.305 252.312L557.533 252.067L463.561 242.131L417.773 239.568L371.092 241.706L340.17 246.888L318.473 252.396L302.457 257.839L287.675 263.951L276.875 269.094L257.736 280.272L245.138 288.988L231.971 299.641L220.229 310.963L211.326 321.837L205.362 330.178L199.59 340.53L196.09 349.019L192.781 358.625L190.61 368.527L189.481 378.132L189.405 382.552L189.3 388.553L189.877 398.38L191.876 408.28L194.348 417.288L197.198 425.104L200.712 432.546L207.546 443.338L212.955 451.152L218.268 457.402L223.962 463.579L230.318 469.382L237.716 475.26L248.906 483.147L257.82 488.353L266.26 492.592L275.363 496.645L283.517 499.878L290.201 502.183L302.763 505.899L313.382 508.313L315.704 508.851L320.54 509.631L326.131 510.167L332.411 510.759L338.644 511.054L350.325 511.402L358.572 511.248L366.581 510.501L374.305 509.269L488.64 485.461L519.312 479.5L533.182 476.803L604.4 462.66L626.625 458.07L637.428 456.353L645.153 455.753L651.172 455.863L656.526 456.269L661.835 457.124L667.713 458.535L672.882 460.356L678.381 462.699L681.746 464.596L685.492 467.274L689.476 470.585L692.702 473.338L701.808 482.341L739.144 519.265L777.126 556.827L781.3 562.036L784.057 565.867L785.812 569.657L787.5 574.165L787.944 576.595L788.249 580.623L788.031 584.143L787.367 588.159L785.457 593.872L783.513 597.606L781.064 601.944L769.74 619.905L739.144 664.815H739.143L682.273 748.292L676.129 757.745L673.291 763.702L671.399 768.914L670.931 774.571L670.745 780.305L671.887 786.558L673.882 792.067L675.876 796.532L679.577 801.965L684.606 807.546L689.443 811.862L696.84 816.622L704.708 820.49L709.259 822.163L715.611 823.983L720.304 824.912L727.175 825.877L731.916 825.987L736.37 825.686L739.143 825.348H739.144L740.967 825.126L761.653 822.084L854.084 809.282L929.325 799.327L944.847 796.803L983.356 787.784L1043.57 773.378L1080.65 764.497L1174.11 741.889L1246.3 724.293L1366.36 695.727L1452.85 674.701L1478.53 668.66L1517.58 659.189L1576.44 645.314L1643.59 628.967L1654.36 625.333L1662.51 621.383L1668.67 617.659L1674.44 613.114L1678.33 609.316L1681.84 605.147L1684.49 601.497L1686.75 597.253L1689.4 590.255L1690.73 585.116L1691.1 580.427L1691.01 575.066V575.066ZM865.368 295.458L892.012 298.256L1031.14 312.865L1057.68 315.389L1233.51 332.113L1249.34 333.62L1289.35 337.425L1313.43 339.715L1326.51 340.987L1341.71 341.317L1342.68 340.867L1344.63 340.864L1408.88 347.379L1422.03 348.783L1424.65 349.226L1429.32 350.718L1432.04 351.855L1434.13 352.965L1436.6 354.532L1438.47 355.949L1440.32 357.638L1442.86 360.136L1444.19 361.662L1445.27 363.441L1446.6 366.309L1447.02 367.591L1447.74 372.093L1447.75 382.552V383.033L1447.03 429.245L1446.23 435.692L1445.29 439.829L1443.7 444.122L1442.12 446.745L1440.14 449.09L1435.64 453.768L1432.16 456.691L1426.97 459.958L1422.7 461.839L1418.28 463.393L1412.85 464.602L1406.67 465.179L1403.06 465.124L1378.57 464.241L1390.95 462.864L1413.26 458.362L1420.88 454.571L1426.92 447.383L1432.65 436.395L1432.84 435.493V435.493L1433.87 430.515L1434.72 420.315L1434.82 382.553L1434.83 378.251L1434.59 375.311L1433.69 371.44L1431.56 366.787L1429.6 363.699L1427.66 361.391L1423.35 357.969L1419.41 355.849L1415.06 354.177L1410.21 353.21L1399.27 352.003L1381.78 350.335L1376.2 349.802L1342.85 347.226L1333.26 347.391L1332.61 346.529L1332 346.681L1325.72 342.893L1319.16 342.251L1313.43 341.671L1288.95 339.194L1249.99 335.508L1232.7 333.539L1141.58 324.524L1057.11 316.263L1020.31 312.891L968.162 307.764L938.032 304.864L912.905 302.709L887.132 300.314L885.847 300.204L862.354 299.511L861.416 299.493L843.598 298.973L837.578 297.823L833.155 291.906L865.368 295.458V295.458ZM1677.01 583.695L1676 587.629L1673.74 593.597L1672.08 596.691L1670.07 599.466L1667.16 602.922L1664.15 605.868L1663.87 606.084L1660.63 608.638L1659.54 609.498L1654.65 612.452L1647.97 615.686L1638.82 618.78L1572.41 634.943L1513.56 648.816L1474.52 658.286L1448.84 664.329L1362.32 685.362L1242.25 713.929L1170.04 731.53L1076.6 754.13L1039.55 763.007L979.374 777.403L941.467 786.28L926.779 788.67L847.867 799.11L825.875 802.169L761.644 811.102L739.144 814.366V814.365L738.638 814.439L734.72 814.916L731.528 815.131L728.6 815.063L723.207 814.305L719.675 813.607L714.562 812.141L711.32 810.949L704.907 807.798L699.061 804.035L695.451 800.814L691.343 796.254L688.551 792.155L687.047 788.785L685.419 784.295L684.576 779.668L684.723 775.062L685.079 770.773L686.415 767.093L688.782 762.124L694.444 753.408L739.144 687.794L782.013 624.869L793.562 606.55L796.212 601.858L798.577 597.315L800.943 590.242L801.791 585.105L802.071 580.564L801.688 575.501L801.023 571.854L798.933 566.271L796.636 561.314L793.157 556.476L788.405 550.548L739.144 501.833V501.834L712.615 475.599L703.198 466.286L699.572 463.191L695.169 459.53L690.444 456.153L685.723 453.492L679.007 450.632L672.577 448.365L665.245 446.605L658.582 445.533L651.995 445.033L644.631 444.899L635.375 445.617L623.496 447.506L600.953 452.161L529.832 466.286L490.8 473.873L485.213 474.959L371.159 498.708L364.387 499.787L357.591 500.423L353.495 500.498L350.422 500.555L343.761 500.357L339.32 500.225L333.65 499.957L327.791 499.404L322.766 498.922L319.051 498.323L317.255 497.905L312.188 496.754L307.12 495.603L304.778 494.91L295.41 492.138L289.406 490.069L281.881 487.084L273.388 483.302L265.667 479.425L257.651 474.744L247.24 467.407L240.469 462.027L237.637 459.441L234.804 456.855L230.904 452.623L229.603 451.212L227.194 448.377L224.784 445.542L219.792 438.333L213.4 428.236L212.081 425.445L210.324 421.723L207.745 414.65L205.45 406.289L203.632 397.279L203.231 390.458L203.605 387.105L204.692 369.566L204.354 369.721L206.275 360.966L209.326 352.106L212.51 344.384L217.735 335.019L223.163 327.428L223.604 326.888L242.069 308.243L247.78 302.415L254.667 296.844L266.433 288.703L284.589 278.1L294.475 273.392L308.424 267.625L323.347 262.552L343.303 257.488L372.949 252.52L398.401 251.418L414.667 250.667L417.682 250.47L462.143 252.957L553.561 262.609L555.738 262.855L585.431 265.813L607.36 270.207L648.808 277.777L683.25 280.895L728.527 285.455L739.143 286.498L739.144 286.498L759.572 288.506L761.234 288.77L765.804 289.495L773.241 290.632L843.366 304.613L859.956 307.807L867.35 309.292L873.702 311.894L880.624 315.316L889.724 309.991L916.32 312.504L922.779 316.098L936.204 317.249L966.213 320.138L1018.41 325.269L1055.21 328.642L1139.61 336.896L1230.57 345.894L1247.9 347.87L1286.99 351.567L1323.22 355.233L1334.16 355.682L1339.75 354.452L1344.54 354.041L1353.78 354.484L1354.25 353.286H1354.25L1375.48 354.925L1382.73 355.617L1398.1 357.083L1408.88 358.538L1412.66 359.291L1415.93 360.545L1418.9 362.149L1422.28 364.827L1423.61 366.408L1425.19 368.917L1427 372.858L1427.74 375.975L1427.93 378.418L1427.91 382.553L1427.82 420.133L1427 429.899L1425.93 435.094L1418.3 445.549L1411.6 451.379L1386 458.4H1360.52L1282.51 449.002L1279.24 448.829V448.617L1253.64 448.432L1239.84 450.057L1237.41 450.307L1223.41 455.002L1205.49 463.53L1205.48 463.537L1200.28 466.176L1195.31 468.598L1193.82 469.562L1190.04 472.003L1182.02 478.321L1175.47 486.595L1175.32 486.807L1178.94 482.427L1174.81 487.436L1174.8 487.442L1151.8 527.877L1097.18 622.674L1091.22 634.366L1089.93 637.766L1089.28 639.466L1088.83 640.97L1088.14 643.226L1087.86 645.255L1087.58 647.285L1087.63 651.117L1087.99 653.295L1088.34 655.473L1089.14 658.103L1089.53 659.419L1090.96 662.694L1092.85 666.191L1095.37 669.54L1097.74 672.071L1102.34 676.238L1106.18 678.692L1108.51 679.927L1112.01 681.779L1114.71 682.761L1116.51 683.415L1120.59 684.679L1124.86 685.57L1129.6 686.164L1137.89 686.457L1143.91 686.306L1226.74 668.735L1234.55 666.871L1239.67 665.231L1243.56 663.702L1247.77 661.506L1252.04 659.046L1255.87 655.917L1258.9 652.865L1261.74 649.214L1264.06 645.715L1265.91 641.843L1267.04 637.525L1267.56 633.429L1267.24 623.641L1267.29 620.178L1267.86 616.785L1269.21 613.896L1271.35 610.416L1273.89 607.576L1276.45 605.27L1280.08 603.024L1349.28 569.942L1464.38 513.32L1526.43 483.837L1536.16 479.415L1539.12 478.352L1541.64 477.589L1545.74 476.776L1547.64 476.526L1551.51 476.318L1555.73 476.254L1557.9 476.371L1560.92 476.768L1564.62 477.371L1567.98 478.214L1571.24 479.338L1574.66 480.78L1578.36 482.733L1580.85 484.249L1659.54 546.053L1664.56 550.126L1667.65 553.344L1672.21 559.42L1673.92 562.297L1675.27 565.731L1676.3 568.726L1676.8 571.617L1677.21 575.583L1677.3 580.163L1677.01 583.695Z"
          fill="white"
          fill-opacity="0.2"
        />
        <path
          d="M361.169 447.695L293.153 463.18L290.487 455.957L358.504 440.473L361.169 447.695Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M382.823 434.995L384.699 440.024L374.869 442.286L375.503 443.988L363.958 446.645L361.447 439.913L382.823 434.995H382.823Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M391.538 438.075L386.617 439.23L385.267 435.677L390.187 434.522L391.538 438.075V438.075Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M400.256 432.477L391.193 434.786L389.824 431.474L398.888 429.165L400.256 432.477V432.477Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M491.815 423.325L501.77 412.886L505.458 415.054L495.503 425.493L491.815 423.325V423.325Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M489.243 407.319L502.876 403.692L504.694 407.907L491.061 411.534L489.243 407.319V407.319Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M714.45 354.16L711.724 363.288L688.238 358.961L690.963 349.834L714.45 354.16V354.16Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M732.268 322.65L722.497 347.163L686.748 338.371L692.482 323.986L708.495 327.925L709.655 325.018L715.401 326.431L718.281 319.21L732.268 322.65V322.65Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M708.684 319.117L707.352 323.276L698.112 321.452L699.444 317.293L708.684 319.117Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M584.905 312.16L580.421 323.207L571.803 321.05L576.283 310.003L584.905 312.16V312.16Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M576.204 295.925H567.742V305.141H576.204V295.925Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M371.408 231.023L365.464 231.072L365.416 227.347L371.36 227.298L371.408 231.023V231.023Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1054 491.092L1058.39 466.977L1076.83 469.044L1072.45 493.159L1054 491.092V491.092Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M997.456 460.793L982.673 467.419L974.145 455.685L988.928 449.058L997.456 460.793V460.793Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1067.76 440.831L1093.92 443.5L1090.49 464.278L1064.68 461.645L1065.79 454.907L1051.64 453.465L1053.35 443.119L1067.15 444.527L1067.76 440.831V440.831Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M912.182 435.819L908.061 440.873L899.703 436.668L903.823 431.614L912.182 435.819V435.819Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M971.069 415.039L973.443 401.103L1032.11 407.267L1029.73 421.202L971.069 415.039V415.039Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1239.15 401.177L1238.85 405.543L1232.94 405.293L1233.24 400.927L1239.15 401.177V401.177Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1346.85 385.116L1343.76 403.413L1332.17 402.204L1335.27 383.906L1346.85 385.116V385.116Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1043.92 364.239L1042.81 374.083L1017.6 372.331L1018.71 362.487L1043.92 364.239V364.239Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1520.44 361.523L1519.94 369.791L1511.67 369.475L1512.18 361.207L1520.44 361.523V361.523Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M946.57 353.03L945.375 362.837L921.2 361.018L922.395 351.213L946.57 353.03Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1303.59 353.67L1302.53 360.394L1094.63 340.156L1095.69 333.433L1303.59 353.67V353.67Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1069.53 339.173L1067.4 350.27L1055.74 349.159L1056.83 339.225L1051.05 338.566L1051.71 334.472L1055.31 329.035L1068.48 330.481L1069.91 336.659L1069.53 339.173V339.173Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.93 338.892L742.638 331.072L767.322 336.347L764.613 344.165L739.93 338.892V338.892Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1033.44 327.585L1032.12 336.306L927.815 326.578L929.134 317.857L1033.44 327.585V327.585Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1299.63 271.621L1298.97 279.068L1288.54 278.462L1292.54 271.228L1299.63 271.621Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1237.87 272.212L1237.47 276.134L1226.6 275.461L1226.99 271.539L1237.87 272.212Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1124.5 259.682L1119.44 261.999L1109.07 248.045L1114.13 245.728L1124.5 259.682V259.682Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1103.96 251.748L1102.81 261.709L1080.19 260.093L1081.35 250.132L1103.96 251.748V251.748Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1061.06 253.365L1060.24 259.791L1046.06 258.677L1046.88 252.252L1061.06 253.365V253.365Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1032.65 251.962L1022.75 253.138L1021.05 244.333L1030.95 243.155L1032.65 251.962Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1048.62 243.342L1047.58 252.252L1035.53 251.382L1036.57 242.472L1048.62 243.342V243.342Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1073.28 246.191L1079.13 241.591L1083.63 245.121L1077.78 249.721L1073.28 246.191V246.191Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M214.558 404.313L213.59 398.943"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.144 825.466L736.37 825.804L731.916 826.105L727.175 825.995L720.304 825.03L715.611 824.101L709.26 822.281L704.708 820.608L696.84 816.74L689.443 811.98L684.606 807.664L679.577 802.083L675.877 796.651L673.882 792.185L671.887 786.676L670.745 780.424L670.931 774.69L671.399 769.032L673.29 763.82L676.129 757.863L682.273 748.411L739.144 664.934"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.145 519.383L701.808 482.46L692.702 473.457L689.476 470.703L685.492 467.392L681.746 464.714L678.381 462.818L672.882 460.475L667.713 458.654L661.835 457.243L656.526 456.388L651.172 455.982L645.153 455.872L637.428 456.472L626.625 458.189L604.401 462.779L533.181 476.921L532.096 477.455L531.812 477.884L531.6 478.592L531.67 479.485L532.371 481.664"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M256.304 398.018L244.881 382.671"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M206.384 382.671L205.971 382.978L204.456 385.398L203.604 387.224L203.23 390.576L203.631 397.397L205.45 406.408L207.744 414.769L210.323 421.841L213.399 428.354L219.792 438.452L224.784 445.66L229.603 451.331L234.804 456.973L240.469 462.146L247.24 467.526L257.651 474.863L265.667 479.543L273.387 483.42L281.881 487.202L289.405 490.187L295.41 492.257L307.119 495.721L317.255 498.024L319.051 498.441L322.766 499.041L327.791 499.522L333.65 500.075L339.319 500.343L350.422 500.673L357.591 500.541L364.387 499.906L371.159 498.826L485.213 475.077L529.832 466.404L600.953 452.28L623.496 447.624L635.375 445.735L644.631 445.018L651.995 445.151L658.581 445.652L665.246 446.723L672.577 448.484L679.007 450.75L685.722 453.611L690.444 456.271L695.169 459.649L699.572 463.309L703.198 466.404L712.615 475.717L739.145 501.952"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.144 687.914L694.444 753.528L688.781 762.244L686.415 767.213L685.078 770.893L684.723 775.182L684.575 779.788L685.419 784.414L687.046 788.905L688.55 792.275L691.342 796.373L695.45 800.933L699.061 804.155L704.907 807.918L711.319 811.069L714.562 812.261L719.674 813.727L723.207 814.425L728.6 815.183L731.527 815.251L734.72 815.035L738.637 814.559L739.144 814.485"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M528.403 483.284L527.195 482.392L525.369 481.368L523.947 480.698L521.744 479.955L519.312 479.618L488.64 485.58L374.304 509.387L366.581 510.619L358.572 511.367L350.325 511.52L338.643 511.172L332.41 510.878L326.131 510.286L320.539 509.749L315.704 508.97L313.381 508.431L302.762 506.018L290.201 502.301L283.517 499.996L275.363 496.763L266.259 492.711L257.82 488.471L248.906 483.265L237.715 475.379L230.317 469.501L223.962 463.697L218.268 457.52L212.955 451.27L207.546 443.456L200.712 432.664L197.198 425.222L194.348 417.406L191.876 408.398L189.877 398.499L189.3 388.672L189.404 382.671"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M259.481 382.671L259.704 383.573L261.699 387.742L262.53 388.721L262.634 388.311L264.715 383.918L265.592 382.671"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M244.88 382.672L243.93 381.394L239.855 381.099L225.825 379.207L221.086 378.764L217.483 378.802L213.976 379.25L210.707 380.109L208.433 381.152L206.384 382.672"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M189.404 382.671L189.481 378.251L190.61 368.646L192.781 358.744L196.09 349.137L199.59 340.649L205.362 330.297L211.327 321.956L220.229 311.082L231.972 299.76L245.138 289.107L257.736 280.391L276.875 269.213L287.675 264.071L302.457 257.958L318.473 252.515L340.17 247.007"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M343.303 257.606L323.348 262.672L308.424 267.744L294.475 273.512L284.588 278.219L266.433 288.822L254.667 296.964L247.78 302.535L242.068 308.362L240.506 310.633L239.371 312.867L238.757 314.804L238.284 316.703L238.096 318.861L237.956 320.983L238.48 323.142L239.097 324.965L240.426 327.608L242.514 330.473L244.98 333.338L259.493 345.762L262.244 348.814L263.764 351.046L265.189 354.545L265.712 357.634L265.857 360.723L265.48 362.697L264.581 365.227L262.878 368.766L260.7 371.856L259.817 372.845L258.655 376.427L258.563 378.958L259.482 382.671"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.144 286.617L728.527 285.574L683.25 281.014L648.808 277.896L607.36 270.326L585.431 265.932L555.738 262.974L553.561 262.728L462.143 253.076L417.682 250.589L414.667 250.786L398.402 251.537L372.949 252.639L343.303 257.607"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M340.17 247.007L371.092 241.825L417.773 239.688L463.56 242.25L557.533 252.186L560.305 252.431L701.785 266.562L739.144 269.889"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M223.603 327.007L223.162 327.547L217.734 335.138L212.509 344.503L209.326 352.224L206.274 361.084L204.354 369.839L204.692 369.684L210.492 368.161L216.21 367.431L221.847 367.37L227.91 367.938L239.048 369.439L240.39 369.364L241.502 369.148L242.616 368.84L243.469 368.411L245.719 366.689L247.968 364.474L249.412 362.798L250.429 361.346L250.997 360.247L251.399 358.796L251.516 357.399L251.515 356.152L251.254 354.979L250.85 353.901L249.807 351.904L235.203 339.402L229.579 335.058L226.353 331.542L224.858 329.402L224.075 328.026L223.603 327.007V327.007Z"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1637.47 602.39L1638.84 599.319"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M761.652 822.204L740.967 825.245L739.145 825.466"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.145 664.934L769.74 620.024L781.064 602.062L783.513 597.724L785.457 593.99L787.367 588.278L788.031 584.261L788.249 580.742L787.944 576.713L787.5 574.283L785.812 569.775L784.057 565.985L781.3 562.155L777.126 556.945L739.145 519.383"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M854.084 809.4L761.652 822.203"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.145 501.951L788.405 550.667L793.156 556.595L796.636 561.433L798.933 566.39L801.023 571.972L801.688 575.619L802.071 580.682L801.791 585.223L800.942 590.36L798.577 597.434L796.212 601.977L793.561 606.668L782.013 624.988L739.145 687.913"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.145 814.485L761.644 811.221"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M761.644 811.22L825.875 802.287L847.867 799.229"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1131.81 651.019L1143.06 675.374L1222.93 658.431L1229.93 656.761L1233.96 655.468L1236.62 654.423L1239.87 652.732L1242.91 650.974L1245.43 648.922L1247.54 646.801L1249.72 643.995L1251.43 641.413L1252.61 638.947L1253.38 636.006L1253.74 633.147L1253.44 623.839L1253.5 619.523L1254.3 614.797L1254.68 613.657L1256.48 609.784L1259.41 605.019L1263.01 600.998L1266.89 597.497L1272.2 594.219L1342.03 560.836L1457.14 504.205L1519.4 474.623L1529.82 469.89L1533.75 468.474L1537.46 467.355L1542.9 466.273L1546.03 465.863L1550.92 465.599L1556.08 465.524L1559.51 465.708L1563.47 466.228L1568.14 466.989L1572.88 468.177L1577.29 469.702L1581.79 471.598L1586.44 474.053L1589.99 476.21L1669.37 538.566L1675.07 543.178L1679.14 547.42L1684.45 554.49L1686.82 558.51L1688.54 562.827L1689.87 566.697L1690.53 570.569L1691.01 575.184L1691.1 580.545L1690.73 585.235L1689.4 590.373L1686.75 597.371L1684.49 601.616L1681.84 605.265L1678.33 609.434L1674.44 613.232L1668.67 617.777L1662.51 621.502L1654.36 625.451L1643.59 629.085L1576.44 645.433L1517.58 659.307L1478.53 668.779L1452.85 674.819L1366.36 695.845L1246.29 724.412L1174.11 742.007L1080.65 764.615L1043.57 773.497L983.356 787.903L944.846 796.921L929.325 799.446L854.084 809.4"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M847.867 799.228L926.779 788.788L941.467 786.398L979.374 777.521L1039.55 763.125L1076.6 754.248L1170.04 731.648L1242.25 714.047L1362.32 685.48L1448.84 664.447L1474.52 658.405L1513.56 648.934L1572.41 635.061L1638.82 618.898L1647.97 615.804L1654.65 612.57L1659.54 609.616L1660.63 608.756L1637.47 602.388"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1195.31 468.716L1200.28 466.294L1205.49 463.648"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1638.84 599.318L1663.87 606.202L1664.15 605.986L1667.16 603.04L1670.07 599.585L1672.08 596.809L1673.74 593.715L1676 587.748L1677.01 583.813L1677.3 580.282L1677.21 575.702L1676.8 571.735L1676.3 568.845L1675.27 565.85L1673.92 562.416L1672.21 559.539L1667.65 553.463L1664.56 550.245L1659.54 546.171L1580.85 484.368L1578.36 482.852L1574.65 480.899L1571.24 479.456L1567.98 478.332L1564.62 477.49L1560.92 476.887L1557.9 476.49L1555.73 476.373L1551.51 476.436L1547.64 476.645L1545.74 476.895L1541.64 477.708L1539.12 478.471L1536.16 479.534L1526.43 483.956L1464.38 513.438L1349.28 570.061L1280.08 603.143L1276.45 605.388L1273.89 607.694L1271.35 610.535L1269.21 614.015L1267.86 616.904L1267.29 620.297L1267.24 623.759L1267.56 633.548L1267.04 637.643L1265.91 641.961L1264.06 645.834L1261.74 649.333L1258.9 652.983L1255.87 656.036L1252.03 659.164L1247.77 661.624L1243.56 663.821L1239.67 665.35L1234.55 666.99L1226.74 668.854L1143.91 686.424L1137.89 686.576L1129.6 686.282L1124.86 685.689L1120.59 684.797L1116.51 683.534L1112.01 681.898L1106.18 678.811L1102.34 676.357L1097.74 672.19L1095.37 669.659L1092.85 666.309L1090.96 662.813L1089.53 659.537L1088.34 655.591L1087.63 651.236L1087.58 647.403L1088.14 643.345L1089.28 639.585L1091.22 634.485L1097.18 622.793L1151.8 527.996L1174.8 487.561"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1465.69 382.671V383.233L1464.96 430.135L1464.02 437.728L1462.79 443.164L1460.52 449.269L1457.78 453.812L1454.79 457.351L1449.39 462.974L1444.38 467.181L1437.03 471.801L1430.78 474.558L1424.43 476.795L1416.37 478.585L1407.55 479.408L1398.09 479.262L1262.3 468.538L1251.68 467.955L1242.2 467.662L1238.39 467.719L1234.85 467.925L1231.21 468.392L1227.13 469.139L1222.87 470.294L1217.23 472.382L1213.01 474.282L1208.32 476.741L1203.25 479.908L1200.13 482.03L1195.39 485.494L1189.9 490.652L1187.29 493.65L1185.16 496.591L1179.09 506.604L1164.39 532.443L1109.88 627.046L1104.27 638.059L1102.62 642.389L1101.77 645.192L1101.39 647.938L1101.42 650.486L1101.94 653.646L1102.81 656.53L1103.85 658.929L1105.2 661.41L1106.9 663.676L1108.53 665.413L1111.98 668.541L1114.41 670.093L1118.81 672.421L1121.95 673.563L1124.91 674.48L1127.72 675.069L1131 675.478L1137.98 675.726L1138.81 675.705L1127.86 652.009"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1434.82 382.671L1434.72 420.433L1433.87 430.633L1432.65 436.514"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1425.93 435.212L1427 430.017L1427.82 420.251L1427.91 382.671"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1233.4 456.862L1239.44 456.664L1281.74 458.738L1360.04 463.691L1403.06 465.242L1406.67 465.297L1412.85 464.72L1418.28 463.512L1422.7 461.957L1426.97 460.077L1432.16 456.81L1435.64 453.886L1440.14 449.208L1442.11 446.864L1443.7 444.241L1445.29 439.947L1446.23 435.811L1447.03 429.364L1447.75 383.151V382.671"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1260.23 318.215L1411.24 333.526L1425.13 335.009L1429.96 335.826L1436.94 338.058L1441.3 339.879L1444.8 341.738L1448.5 344.082L1451.53 346.389L1454.15 348.77L1457.27 351.858L1459.79 354.724L1461.83 358.11L1463.77 362.278L1464.68 365.107L1465.67 371.323L1465.69 382.672"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1399.27 352.121L1410.21 353.328L1415.06 354.295L1419.41 355.967L1423.35 358.087L1427.66 361.509L1429.6 363.817L1431.56 366.905L1433.69 371.558L1434.59 375.429L1434.83 378.369L1434.82 382.671"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1427.92 382.671L1427.93 378.536L1427.74 376.093L1427 372.976L1425.19 369.035L1423.61 366.526L1422.28 364.946L1418.9 362.268L1415.93 360.663L1412.66 359.41L1408.88 358.656L1398.1 357.201"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M916.32 312.622L889.723 310.11L880.624 315.435L873.701 312.013L867.35 309.411L859.956 307.926L843.365 304.732L773.24 290.751"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1354.25 353.405L1353.78 354.604L1344.54 354.161L1339.75 354.572L1334.16 355.802L1331.27 357.032L1329.51 358.149L1327.49 360.435"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1323.22 355.353L1286.99 351.687L1247.9 347.99L1230.57 346.013L1139.61 337.016L1055.21 328.762L1018.41 325.389L966.212 320.257L936.204 317.369L922.778 316.218"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1398.1 357.204L1382.73 355.737L1375.48 355.045L1354.25 353.405"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1447.75 382.671L1447.74 372.212L1447.02 367.71L1446.6 366.428L1445.27 363.56L1444.19 361.781L1442.86 360.255L1440.32 357.757L1438.47 356.068L1436.6 354.651L1434.13 353.084L1432.04 351.974L1429.32 350.837L1424.65 349.345L1422.03 348.901L1408.88 347.497L1344.63 340.984L1342.68 340.987L1341.71 341.436L1326.51 341.106L1313.43 339.835"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1319.16 342.37L1325.72 343.012L1333.26 347.51L1342.85 347.346L1376.2 349.921L1381.78 350.454L1399.27 352.123"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1313.43 341.79L1319.16 342.37"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M861.416 299.612L862.354 299.63L885.847 300.324L887.132 300.434L912.905 302.828L938.032 304.983L968.162 307.883L1020.31 313.011L1057.11 316.383L1141.58 324.644L1232.7 333.658L1249.99 335.628L1288.95 339.314L1313.43 341.791"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1313.43 339.835L1289.35 337.545L1249.34 333.739L1233.51 332.233L1057.68 315.508L1031.14 312.985L892.012 298.375L865.368 295.577L833.154 292.025"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M761.22 271.854L829.878 277.97L852.621 279.995L936.314 287.929L953.598 289.567L1011.26 295.033L1072.72 300.86L1079.47 301.5L1148.07 307.842L1174.74 310.307L1260.23 318.214"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M833.154 292.025L837.578 297.942L843.598 299.093L861.416 299.612"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M773.241 290.751L765.804 289.614L761.234 288.889"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M761.234 288.889L759.572 288.625L739.145 286.617"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M739.145 269.888L761.22 271.853"
          stroke="white"
          stroke-width="0.1"
          stroke-linecap="square"
          stroke-linejoin="bevel"
        />
        <path
          d="M1192.63 664.859L1143.06 675.375L1138.81 675.705L1137.98 675.727L1131 675.479L1127.73 675.07L1124.91 674.481L1121.95 673.563L1118.81 672.422L1114.41 670.094L1111.98 668.542L1108.53 665.414L1106.9 663.677L1105.2 661.41L1103.85 658.93L1102.81 656.531L1101.94 653.646L1101.42 650.487L1101.39 647.939L1101.77 645.193L1102.62 642.389L1104.27 638.059L1109.88 627.047L1164.39 532.444L1179.09 506.605L1185.16 496.592L1187.29 493.65L1189.9 490.653L1195.39 485.495L1200.13 482.031L1203.25 479.908L1208.32 476.742L1213.01 474.283L1217.23 472.383L1222.87 470.295L1227.13 469.14L1231.21 468.393L1234.86 467.926L1238.39 467.719L1242.2 467.662L1251.68 467.955L1262.3 468.538L1398.09 479.262L1407.55 479.409L1416.37 478.585L1424.43 476.795L1430.78 474.558L1437.03 471.801L1444.38 467.182L1449.39 462.975L1454.79 457.351L1457.78 453.813L1460.52 449.27L1462.79 443.165L1464.02 437.729L1464.96 430.136L1465.69 383.234V382.672L1465.68 371.323L1464.68 365.106L1463.77 362.278L1461.83 358.11L1459.79 354.724L1457.27 351.857L1454.15 348.769L1451.53 346.388L1448.5 344.081L1444.8 341.737L1441.3 339.878L1436.94 338.056L1429.96 335.825L1425.13 335.008L1411.24 333.525L1260.23 318.214H1260.23L1174.74 310.307L1148.07 307.842L1099.33 303.336"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1028.2 777.176L1043.57 773.498L1080.65 764.616L1174.11 742.008L1246.29 724.413L1366.36 695.846L1452.85 674.82L1478.53 668.78L1517.58 659.308L1576.44 645.434L1643.59 629.086L1654.36 625.452L1662.51 621.503L1668.67 617.778L1674.44 613.233L1678.33 609.435L1681.84 605.266L1684.49 601.617L1686.75 597.372L1689.4 590.374L1690.73 585.236L1691.1 580.546L1691.01 575.185L1690.53 570.57L1689.87 566.698L1688.54 562.828L1686.82 558.511L1684.45 554.491L1679.14 547.421L1675.07 543.179L1669.37 538.567L1589.99 476.212L1586.44 474.054L1581.79 471.599L1577.29 469.703L1572.88 468.178L1568.14 466.99L1563.47 466.229L1559.51 465.709L1556.08 465.525L1550.92 465.6L1546.03 465.864L1542.9 466.274L1537.46 467.356L1533.75 468.475L1529.82 469.891L1519.4 474.624L1457.14 504.206L1342.03 560.837L1272.2 594.22L1266.89 597.497L1263.01 600.999L1259.41 605.02L1256.48 609.785L1254.68 613.658L1254.3 614.798L1253.5 619.524L1253.44 623.84L1253.74 633.148L1253.38 636.007L1252.61 638.948L1251.43 641.414L1249.72 643.996L1247.54 646.802L1245.43 648.923L1242.91 650.975L1239.87 652.733L1236.62 654.424L1233.96 655.469L1229.93 656.762L1222.93 658.432L1192.63 664.86"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M504.921 482.417L519.312 479.619L533.181 476.922L604.4 462.78L626.624 458.19L637.427 456.473L645.152 455.873L651.172 455.983L656.526 456.389L661.835 457.244L667.713 458.655L672.881 460.476L678.381 462.819L681.746 464.715L685.492 467.393L689.475 470.704L692.701 473.458L701.808 482.461L739.144 519.384L777.125 556.946L781.299 562.156L784.057 565.987L785.811 569.777L787.5 574.284L787.943 576.714L788.249 580.743L788.031 584.262L787.367 588.279L785.457 593.992L783.513 597.726L781.063 602.064L769.74 620.025L739.144 664.935H739.143L682.273 748.412L676.129 757.865L673.29 763.821L671.399 769.033L670.93 774.691L670.745 780.425L671.887 786.678L673.882 792.186L675.876 796.652L679.577 802.085L684.605 807.666L689.443 811.982L696.839 816.742L704.708 820.609L709.259 822.283L715.61 824.103L720.303 825.031L727.175 825.997L731.916 826.106L736.37 825.806L739.143 825.467H739.144L740.967 825.246L761.652 822.204L854.084 809.401L929.325 799.447L944.846 796.923L983.356 787.904L1028.2 777.176"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1099.33 303.337L1079.47 301.5L1072.72 300.861L1011.26 295.034L953.598 289.568L936.314 287.929L852.621 279.995L829.878 277.97L761.22 271.854L739.144 269.889L701.785 266.562L560.305 252.431L557.533 252.186L463.56 242.25L417.773 239.688L371.092 241.825L340.17 247.007L318.472 252.515L302.457 257.958L287.675 264.071L276.875 269.213L257.736 280.391L245.138 289.107L231.971 299.76L220.229 311.082L211.326 321.956L205.362 330.297L199.59 340.649L196.09 349.138L192.781 358.744L190.61 368.646L189.481 378.251L189.404 382.672L189.3 388.673L189.877 398.499L191.876 408.399L194.348 417.407L197.198 425.223L200.712 432.665L207.546 443.457L212.955 451.271L218.268 457.521L223.962 463.698L230.317 469.501L237.715 475.38L248.906 483.266L257.82 488.472L266.259 492.711L275.363 496.764L283.517 499.997L290.201 502.302L302.762 506.018L313.382 508.432L315.704 508.971L320.539 509.75L326.131 510.286L332.41 510.879L338.643 511.173L350.325 511.521L358.572 511.367L366.581 510.62L374.304 509.388L488.64 485.581L504.921 482.416"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M1097.02 320.286L1057.11 316.383L1020.31 313.011L968.162 307.883L938.031 304.983L912.905 302.828L887.131 300.434L885.847 300.324L862.354 299.63L861.416 299.612L843.598 299.093L837.578 297.942L833.154 292.025L865.368 295.577L892.012 298.375L1031.14 312.985L1057.68 315.508L1097.16 319.263"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M1233.16 456.864L1241.01 454.741L1256.17 453.368L1279.24 454.639L1299.41 456.958L1332.08 460.749L1360.04 463.693L1378.57 464.361L1390.95 462.983L1413.26 458.482L1420.88 454.69L1426.92 447.503L1432.65 436.515L1433.87 430.635L1434.72 420.435L1434.82 382.672L1434.83 378.371L1434.59 375.431L1433.69 371.56L1431.56 366.907L1429.6 363.818L1427.66 361.511L1423.35 358.089L1419.41 355.969L1415.06 354.297L1410.21 353.33L1399.27 352.123L1381.78 350.454L1376.19 349.922L1342.85 347.346L1333.26 347.51L1325.72 343.013L1319.16 342.371L1313.43 341.791L1288.95 339.314L1249.99 335.628L1232.7 333.658L1141.58 324.644L1097.02 320.286"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M502.503 471.717L485.213 475.078L371.159 498.827L364.387 499.907L357.591 500.542L350.422 500.674L339.319 500.344L333.649 500.076L327.791 499.523L322.766 499.041L319.051 498.442L317.254 498.025L307.119 495.722L295.41 492.257L289.405 490.188L281.881 487.203L273.387 483.421L265.667 479.544L257.651 474.864L247.24 467.527L240.469 462.147L234.804 456.974L229.603 451.332L224.784 445.661L219.792 438.453L213.399 428.355L210.323 421.842L207.744 414.769L205.45 406.409L203.631 397.398L203.23 390.577L204.354 369.84L206.275 361.085L209.326 352.225L212.509 344.503L217.734 335.138L223.162 327.547L223.603 327.007L242.068 308.362L247.779 302.534L254.667 296.963L266.433 288.822L284.588 278.219L294.474 273.511L308.423 267.743L323.347 262.671L343.302 257.607L372.949 252.639L398.401 251.537L414.667 250.786L417.682 250.589L462.143 253.076L553.561 262.728L555.738 262.974L585.43 265.932L607.359 270.326L648.807 277.896L683.25 281.014L728.527 285.574L739.143 286.617L739.144 286.617L759.572 288.625L761.234 288.889L765.803 289.614L773.241 290.751L843.366 304.732L859.956 307.926L867.35 309.411L873.701 312.013L880.624 315.435L889.724 310.11L916.32 312.623L922.778 316.217L936.204 317.368L966.212 320.256L1018.41 325.388L1055.21 328.761L1095.33 332.684"
          stroke="#FFF38A"
          stroke-width="0.1"
        />
        <path
          d="M1025.37 766.518L979.374 777.523L941.467 786.4L926.779 788.789L847.867 799.23L825.876 802.288L761.644 811.221L739.144 814.485V814.484L738.638 814.558L734.72 815.035L731.528 815.251L728.6 815.183L723.207 814.425L719.675 813.726L714.562 812.26L711.319 811.068L704.907 807.917L699.061 804.155L695.451 800.933L691.343 796.373L688.55 792.274L687.046 788.905L685.419 784.414L684.575 779.787L684.723 775.182L685.079 770.892L686.415 767.212L688.782 762.243L694.444 753.527L739.144 687.914L782.013 624.989L793.561 606.669L796.212 601.978L798.577 597.434L800.942 590.361L801.791 585.224L802.071 580.683L801.688 575.62L801.023 571.973L798.933 566.39L796.636 561.434L793.156 556.596L788.405 550.668L739.144 501.952V501.953L712.615 475.718L703.198 466.405L699.572 463.31L695.169 459.65L690.444 456.272L685.722 453.612L679.007 450.751L672.577 448.484L665.246 446.724L658.581 445.653L651.995 445.152L644.631 445.019L635.375 445.736L623.496 447.625L600.953 452.281L529.832 466.405L502.503 471.717"
          stroke="#64E3FF"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1195.12 675.563L1226.74 668.855L1234.55 666.991L1239.67 665.351L1243.56 663.822L1247.77 661.625L1252.04 659.165L1255.87 656.037L1258.9 652.984L1261.74 649.334L1264.06 645.835L1265.91 641.962L1267.04 637.644L1267.56 633.549L1267.25 623.76L1267.29 620.298L1267.86 616.905L1269.21 614.016L1271.35 610.536L1273.89 607.695L1276.45 605.389L1280.08 603.144L1349.28 570.062L1464.38 513.439L1526.43 483.957L1536.16 479.535L1539.12 478.472L1541.64 477.709L1545.74 476.896L1547.64 476.646L1551.51 476.437L1555.73 476.374L1557.9 476.491L1560.92 476.888L1564.63 477.491L1567.98 478.333L1571.24 479.457L1574.66 480.899L1578.36 482.853L1580.85 484.369L1659.54 546.172L1664.56 550.246L1667.65 553.464L1672.22 559.54L1673.92 562.417L1675.27 565.851L1676.3 568.846L1676.8 571.736L1677.21 575.703L1677.3 580.283L1677.01 583.814L1676 587.749L1673.74 593.716L1672.08 596.81L1670.07 599.586L1667.16 603.041L1664.15 605.987L1663.87 606.203L1660.63 608.757L1659.54 609.618L1654.65 612.571L1647.97 615.806L1638.82 618.9L1572.41 635.063L1513.56 648.936L1474.52 658.406L1448.84 664.449L1362.32 685.481L1242.25 714.049L1170.04 731.65L1076.6 754.25L1039.55 763.127L1025.37 766.52"
          stroke="#FD6A6A"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1233.04 456.864L1239.44 456.666L1281.74 458.739L1360.04 463.693L1403.06 465.243L1406.67 465.298L1412.85 464.721L1418.28 463.513L1422.7 461.959L1426.97 460.078L1432.16 456.811L1435.64 453.887L1440.14 449.209L1442.11 446.865L1443.7 444.242L1445.29 439.949L1446.23 435.812L1447.03 429.365L1447.75 383.153V382.672L1447.74 372.213L1447.02 367.711L1446.6 366.429L1445.27 363.561L1444.19 361.782L1442.86 360.256L1440.32 357.758L1438.47 356.069L1436.6 354.652L1434.13 353.085L1432.04 351.975L1429.32 350.838L1424.65 349.346L1422.03 348.902L1408.88 347.498L1344.63 340.983L1342.68 340.987L1341.71 341.436L1326.51 341.106L1313.43 339.835L1289.35 337.545L1249.34 333.739L1233.51 332.233L1097.16 319.264"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1195.12 675.561L1143.91 686.425L1137.89 686.576L1129.6 686.283L1124.86 685.689L1120.59 684.798L1116.51 683.535L1112.01 681.898L1106.18 678.811L1102.34 676.357L1097.74 672.191L1095.37 669.659L1092.85 666.31L1090.96 662.813L1089.53 659.538L1088.34 655.592L1087.63 651.237L1087.58 647.404L1088.14 643.345L1089.28 639.585L1091.22 634.485L1097.18 622.793L1151.8 527.996L1174.8 487.561L1182.02 478.44L1190.04 472.123L1195.31 468.717L1200.28 466.295L1205.49 463.649"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1095.33 332.685L1139.61 337.015L1230.57 346.013L1247.9 347.989L1286.99 351.686L1323.22 355.352L1334.16 355.802L1339.75 354.572L1344.53 354.161L1353.78 354.604L1354.25 353.405H1354.25L1375.48 355.045L1382.73 355.736L1398.1 357.202L1408.88 358.657L1412.66 359.411L1415.93 360.664L1418.9 362.269L1422.28 364.947L1423.61 366.527L1425.19 369.036L1427 372.977L1427.73 376.094L1427.93 378.537L1427.91 382.672L1427.82 420.252L1427 430.018L1425.92 435.213L1418.3 445.668L1411.6 451.499L1386 458.519H1360.51L1282.51 449.121"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
        <path
          d="M1193.82 469.681L1205.49 463.65L1223.41 455.121L1237.41 450.307L1253.64 448.312L1282.51 449.121"
          stroke="#22DB4B"
          stroke-width="0.1"
          stroke-miterlimit="10"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1521_20445">
        <rect width="1503" height="600" fill="white" transform="translate(189 227)" />
      </clipPath>
      <clipPath id="clip1_1521_20445">
        <rect width="1502.4" height="599.404" fill="white" transform="translate(189 227)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面: GPS詳細 サーキットマップ: SUGO
 */
export default defineComponent({
  name: 'CircuitMapImageSugo',
})
</script>
